/** Display API boolean fields as Yes/No in dropdowns. */
export function booleanToYesNo(value: unknown): string {
  if (value === true || value === 1) return 'Yes';
  if (value === false || value === 0) return 'No';
  return '';
}

export function yesNoToBoolean(value: string): boolean | undefined {
  if (value === 'Yes') return true;
  if (value === 'No') return false;
  return undefined;
}
